<template>
  <div class="date-wrap">
    <div
      v-for="(item, index) in dateList"
      @click="chooseDate(item, index)"
      :class="{'date-item': true, 'date-on': tabOn === index}">
      <p v-if="item.date === currentDay">今天</p>
      <p>{{handleDate(item.saleDate)}}</p>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'x-date',
    props: ['dateList'],
    data () {
      return {
        tabOn: 0,
        currentDay: ''
      }
    },
    created() {
      console.log(this.dateList)
      let date = new Date()
      this.currentDay = moment(date).format("YYYY-MM-DD")
    },
    methods: {
      handleDate (date) {
        moment.locale('cn')
        let str = moment(date).format("MMM Do")
        return str
      },
      chooseDate (item, index) {
        console.log(item, index)
        this.tabOn = index
        this.$emit('dateChange', item)
      },
      inputChange (event) {
        this.$emit('communication', event)
      }
    }
  }
</script>

<style scoped>
  .date-wrap{
    display: flex;
  }
  .date-item{
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 29px;
    text-align: center;
    padding: 0 14px;
    border: #9C9A9B solid 1px;
    background: #fff;
    margin-right: 8px;
    cursor: pointer;
    color: #999999;
    font-weight: 600;
  }
  .date-on{
    animation: changeTab .3s forwards;
  }

  @keyframes changeTab {
    from {background: #fff; border-color: #9C9A9B; color: #000;}
    to {background: #575757; border-color: #575757; color: #fff;}
  }
</style>
